import _ from 'lodash'
import moment from 'moment-mini'

export default ->

	term: (obj, args, context, info) ->
		__typename: 'DatesDuration'
		years: _.ceil moment.unix(obj.expiry).diff moment.unix(obj.commencement), 'years', true
		months: _.ceil moment.unix(obj.expiry).diff moment.unix(obj.commencement), 'months', true
